export const changeAddress = (body: any) => {
	return {
		method: "PUT",
		url: `${process.env.REACT_APP_ORIGIN}/work_order_utility/change-address`,
		body,
	}
}